export default __webpack_public_path__ + "static/media/MODELO CENTRAL.c35c0738.jpg";